import { IconButton, type IconButtonProps } from '@mui/material';
import { Close as CancelIcon } from '@mui/icons-material';

type CancelDeletionButtonProps = Omit<IconButtonProps, 'edge' | 'children'>;

const CancelDeletionButton = (props: CancelDeletionButtonProps) => (
  <IconButton edge="end" size="small" {...props}>
    <CancelIcon fontSize="small" />
  </IconButton>
);

export default CancelDeletionButton;
